// Single source of truth for the auth screens' background (Login, Login OTP,
// SignUp, Verify Number, Verify Email, Verified OTP). Swap the import below to
// change the background everywhere.
//
// Desktop and mobile currently share one image. If a portrait-cropped variant
// is added, import it separately and export it as AuthMobileBG.
import AuthBG from './Images/auth-bg.jpg';

export { AuthBG };
export const AuthMobileBG = AuthBG;
